<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item>

        <!-- 复合日期搜索框 -->
        <CompositeFormDate ref="comFormDate" :type="'daterange'" :options="searchDateOptions"
          @onChange="onComSelectSearchChange">
        </CompositeFormDate>
      </template>
      <!-- 表头设置控件 -->
      <!-- <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template> -->
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'declaration',
      breadcrumb: [
        { name: "报单管理" },
        { name: "报单列表" },
      ],
      formCtrl: [
        {
          label: "货物名称",
          keyName: "product",
          placeholder: "请填写货物名称",
          type: "text",
        },
      ],
      searchDateOptions: [
        { ...this.ctrls.ZhuangHuoRiQi, },
        { ...this.ctrls.XieHuoRiQi, },
        {
          label: "提交时间",
          keyName: "submitted_at",
          placeholder: "请选择提交时间",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { keyName: "product", label: "货物名称", minwidth: 120 },
        { keyName: "pricing", label: "计价方式", minwidth: 120 },
        { keyName: "quantity", label: "下单量", minwidth: 120 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { keyName: "predict_loading_date", label: "装货日期", minwidth: 120 },
        { keyName: "predict_unloading_date", label: "卸货日期", minwidth: 120 },
        { keyName: "created_at", label: "提交日期", minwidth: 120 },
      ],
      btns: [
        {
          class: 'dispatchbtn',
          title: '再报一单',
          img: require('@/assets/img/icon-paidan.png'),
          unimg: require('@/assets/img/icon-paidan-hover.png'),
          cb: ({ id }) => {
            this.$router.push(`/reportOrder/add?id=${id}`)
          },
        },
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id }) => {
            this.$router.push(
              `/reportOrder/cdetail?id=${id}&mode=view`
            );
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(`/reportOrder/cdetail?id=${id}&mode=edit`)
          },
        },
        {
          ...this.delBtn,
          cb: ({ id }) => {
            this.delete(id)
          },
        },
      ],
      delUrl: 'delete',
      // baseParams: [''],
    };
  },
  methods: {
    addItem() {
      this.$router.push(
        `/reportOrder/add`
      )
      // console.log(this.tableData)
    },
  },
  created() {
    // const { user_group_id, id } = this.user
    // if (user_group_id == 1) {
    //   this.btns[0] = {
    //     ...this.editBtn,
    //     cb: ({ id, car_type }) => {
    //       this.$router.push(
    //         `/vehicle/inspectdetail?id=${id}&car_type=${car_type}&mode=edit`
    //       );
    //     },
    //   }
    // } else if (user_group_id == 5) {
    //   this.formInline.fleet = id
    //   this.formCtrl.splice(0, 1)
    //   this.baseParams.push('fleet')
    // }
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>